export default __webpack_public_path__ + "static/media/logosN6.2a3259e8.jpg";